// @ts-ignore
import Vue from 'vue';
// @ts-ignore
import { Component, Prop } from "vue-property-decorator";

//Render
import WithRender from "Components/Shared/WorkbenchCard/workbench-card.html";

//API Service
import FavoritesService from "Services/favoritesService"

@WithRender
@Component()

export default class WorkbenchCard extends Vue {
	@Prop({}) baseUrl!: string;
	@Prop({}) urlName!: string;
	@Prop({}) heroImage!: string;
	@Prop({}) heroImageAltText!: string;
	@Prop({}) ambassadorImage!: string;
	@Prop({}) ambassadorImageNormal!: string;
	@Prop({}) ambassadorImageNormalAltText!: string;
	@Prop({}) ambassadorDisplayTitle!: string;
	@Prop({}) projectTitle!: string;
	@Prop({}) projectType!: any;
	@Prop({}) difficulty!: any;
	@Prop({}) time!: any;
	@Prop({}) translations!: any;
	isFavorites: boolean;

	created(){
		let vm = this;		
		vm.setFavorites(vm.urlName);
	}
	
	setFavorites(urlName:string)
	{
		let vm = this;
		let projectIds = this.getFavoriteProjects();
            if (urlName != null) {
                if (projectIds.indexOf(urlName) > -1) {
                    vm.isFavorites = true;
                } else {
                    vm.isFavorites = false;
                }
            }		
	}
	getFavoriteProjects(): string[] {
		let projectIds: string[] = [];
		if (localStorage.getItem('favorite-projects')) {
			projectIds = JSON.parse(localStorage.getItem('favorite-projects'));
		}
		return projectIds;
	}	
}

